<template lang="pug">
v-autocomplete(
	v-bind="$attrs" v-on="$listeners"
	item-text="name"
	item-value="id"
	v-model="destination"
	:items="searchResults"
	:search-input.sync="search"
	return-object
	no-filter
	chip
	)
	template(#item="{item, on}")
		v-list-item(dense v-on="on")
			v-list-item-avatar(size="20" tile)
				img.flag.ma-0(:src="`https://static.wintersport.nl/images/flags/svg/${item.countryCode || item.country.countryCode}.svg`")
			v-list-item-content {{item.name}}
				.caption(v-if="item.resortName") {{item.resortName}}
			v-list-item-avatar(size="20")
				ws-icon(small) {{icons[item.type]}}
</template>

<style lang="sass">
.searchbar
  // padding-right: 0 !important
  .v-autocomplete__content .v-list__item__avatar
    min-width: 35px
  // .v-input__append-inner
    margin-top: 0 !important
</style>

<script>
import gql from 'graphql-tag';
import debounce from 'lodash/debounce';

export default {
	props: {
		types: {
			type: Array,
			default() {
				return ['areas', 'resorts'];
			}
		},
		limit: {
			type: Number,
			default: 50
		}
	},
	data() {
		return {
			abortController: null,
			isFetchingAccommodations: false,
			isLoading: false,
			destination: null,
			entries: [],
			accommodations: [],
			search: '',
			icons: {
				Area: 'ski',
				Resort: 'village',
				Cluster: 'ski',
				Organisation: 'organisation',
				Skihall: 'skihall',
				Revolvingslope: 'revolvingslope',
				Dryslope: 'dryslope',
				Carpetslope: 'carpetslope',
				Accommodation: 'bed'
			}
		};
	},
	computed: {
		searchResults() {
			return [
				{ header: 'Zoekresultaten' },
				...this.entries,
				...this.accommodations,
				// { divider: true },
				// { header: 'Recente zoekopdrachten' },
				// { name: 'Winterberg', type: 'Area' },
				{ divider: true },
				{ header: 'Populaire bestemmingen' },
				{ name: 'Tirol', type: 'Region', countryCode: 'at', slug: 'tirol' },
				{ name: 'Oostenrijk', type: 'Country', countryCode: 'at' },
				{ name: 'Franrijk', type: 'Country', countryCode: 'fr' },
				{ name: 'Italië', type: 'Country', countryCode: 'it' }
			];
		}
	},
	watch: {
		search(val) {
			if (val == null || val === '') return false;
			this.isLoading = true;

			const searchQuery = gql`
				query search($val: String!, $types: [String]!, $limit: Int!) {
					search(term: $val, types: $types, limit: $limit) {
						type: __typename
						... on Area {
							id
							name
							slug
							country {
								id
								countryCode
							}
						}
						... on Resort {
							id
							name
							slug
							area {
								id
							}
							country {
								id
								countryCode
							}
						}
						... on Region {
							id
							name
							slug
							country {
								id
								countryCode
							}
						}
						... on Country {
							id
							name
							slug
							countryCode
						}
					}
				}
			`;

			this.$graphClient
				.query({
					query: searchQuery,
					variables: {
						val,
						types: this.types,
						limit: this.limit
					}
				})
				.then(res => res.data)
				.then(data => {
					this.entries = data.search;
				})
				.catch(_err => {})
				.finally(() => (this.isLoading = false));

			const accommodationsQuery = gql`
				query mergedAccommodationsByName($name: String!, $limit: Int!) {
					mergedAccommodationsByName(name: $name, limit: $limit) {
						__typename
						id
						name
						type
						resort {
							id
							name
							slug
							country {
								id
								countryCode
							}
						}
					}
				}
			`;

			if(this.isFetchingAccommodations) this.abortController.abort();
			if(val.length >= 4) {
				debounce(() => {
					this.abortController = new AbortController();
					const signal = this.abortController.signal;
					this.isFetchingAccommodations = true;
					this.$graphClient
						.query({
							query: accommodationsQuery,
							variables: {
								name: val,
								limit: 15
							},
							context: {
								fetchOptions: {
									signal
								}
							}
						})
						.then(res => res.data)
						.then(data => {
							this.accommodations = data.mergedAccommodationsByName.map(accommodation => {
								return {name: `${accommodation.name}`, type: accommodation.__typename, slug: accommodation.id, countryCode: accommodation.resort.country.countryCode, resortName: accommodation.resort.name}
							});
							this.isFetchingAccommodations = false;
						})
						.catch(_err => {
							this.isFetchingAccommodations = false;
						});
				}, 250)()
			} else {
				this.accommodations = [];
			}
		}
	}
};
</script>
